
import React from "react";
import { FileText, Phone, MessageCircle, Mail } from "lucide-react";

const DetailsStep = ({ installationData, handleInputChange, errors }) => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <FileText className="w-16 h-16 text-emerald-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Project Details
        </h2>
        <p className="text-gray-600">
          Additional information for your installation
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            How should we contact you?
          </label>
          <div className="grid md:grid-cols-3 gap-4">
            {[
              {
                id: "phone",
                label: "Phone Call",
                icon: Phone,
                description: "Direct phone calls",
              },
              {
                id: "text",
                label: "Text Message",
                icon: MessageCircle,
                description: "SMS updates",
              },
              {
                id: "email",
                label: "Email",
                icon: Mail,
                description: "Email notifications",
              },
            ].map((method) => {
              const IconComponent = method.icon;
              return (
                <button
                  key={method.id}
                  onClick={() => handleInputChange("contactMethod", method.id)}
                  className={`p-6 rounded-2xl border-2 text-center transition-all duration-300 ${
                    installationData.contactMethod === method.id
                      ? "border-emerald-500 bg-emerald-50 text-emerald-700 shadow-lg shadow-emerald-500/20"
                      : "border-gray-200 hover:border-gray-300 hover:shadow-sm"
                  }`}
                >
                  <IconComponent className="w-8 h-8 mx-auto mb-3" />
                  <div className="font-semibold text-lg">{method.label}</div>
                  <div className="text-sm opacity-70 mt-1">
                    {method.description}
                  </div>
                </button>
              );
            })}
          </div>
          {errors.contactMethod && (
            <p className="text-red-500 text-sm mt-1">{errors.contactMethod}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Special Instructions (Optional)
          </label>
          <textarea
            value={installationData.specialInstructions}
            onChange={(e) =>
              handleInputChange("specialInstructions", e.target.value)
            }
            rows={4}
            className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all resize-none text-lg"
            placeholder="Any specific requirements, concerns, or preferences for the installation..."
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Property Access Information (Optional)
          </label>
          <textarea
            value={installationData.accessInstructions}
            onChange={(e) =>
              handleInputChange("accessInstructions", e.target.value)
            }
            rows={4}
            className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all resize-none text-lg"
            placeholder="Gate codes, parking instructions, pet information, or any access details the crew should know..."
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Emergency Contact (Optional)
          </label>
          <input
            type="text"
            value={installationData.emergencyContact}
            onChange={(e) =>
              handleInputChange("emergencyContact", e.target.value)
            }
            className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all text-lg"
            placeholder="Emergency contact name and phone number"
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsStep;
